module.exports = __webpack_public_path__ + "img/about-us-banner.7dafe22a.png";